import React from 'react'

import { formatCurrency } from '../../../../utilities/helpers'

import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Stack from 'react-bootstrap/Stack'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

import { InfoIcon } from '../../../InfoIcon'
import { LinkBankAccountBtn } from '../../LinkBankAccountBtn'

import './withdrawCards.scss'

export default function WithdrawCards({ account, funds, fundsOnHold }) {
  return (
    <Stack gap={4}>
      <Card body className="withdraw-card card--dark">
        <Card.Title as="h5" className="light">
          Depositing to your bank
        </Card.Title>
        <span className="total">{formatCurrency(funds || 0)}</span>
        <p className="small mb-0">
          Payouts are deposited after the event. You do not need to withdraw
          them.
        </p>
        {account && account.hasOwnProperty('id') ? null : (
          <LinkBankAccountBtn />
        )}
      </Card>
      <Card body className="withdraw-card position-relative">
        <Card.Title as="h5">Funds On Hold</Card.Title>
        <OverlayTrigger
          placement="bottom"
          overlay={
            <Tooltip>
              Held until the event ends, then deposited to your bank.
            </Tooltip>
          }
        >
          <Button
            variant="link"
            className="position-absolute"
            style={{ top: '21px', right: '16px' }}
          >
            <InfoIcon />
          </Button>
        </OverlayTrigger>
        <span className="total">{formatCurrency(fundsOnHold || 0)}</span>
      </Card>
    </Stack>
  )
}
